import React from "react";
import { ChevronDown } from "lucide-react";

const DashboardTable = ({ headers, data, children }) => {
  return (
    <div className="w-full">
      <table className="min-w-full bg-white border-collapse">
        {/* Table Header */}
        <thead>
          <tr className="text-black text-[11px] sm:text-xs md:text-sm font-semibold border-b border-gray-300 bg-white">
            {headers.map((header, index) => (
              <th key={index} className="text-left px-3 py-2 whitespace-nowrap">
                <div className="flex items-center gap-1">
                  {header}
                  <ChevronDown size={14} className="text-gray-500" />
                </div>
              </th>
            ))}
          </tr>
        </thead>

        {/* Table Body */}
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="hover:bg-gray-50 cursor-pointer [&>td]:py-2 [&>td]:text-[11px] sm:[&>td]:text-xs md:[&>td]:text-sm"
            >
              {children(row, rowIndex)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardTable;
